import { render, staticRenderFns } from "./ListaArchiviati.vue?vue&type=template&id=06f0b934"
import script from "./ListaArchiviati.vue?vue&type=script&lang=js"
export * from "./ListaArchiviati.vue?vue&type=script&lang=js"
import style0 from "./ListaArchiviati.vue?vue&type=style&index=0&id=06f0b934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports